import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, LOCALE_ID, Inject } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@arematics/core/api';
import { PipesModule } from '@arematics/core/api';
import * as i1 from '@angular/router';

class DocumentComponent {
    document;
    constructor(activatedRoute) {
        if (activatedRoute.snapshot.data['document']) {
            this.document = activatedRoute.snapshot.data['document'];
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DocumentComponent, deps: [{ token: i1.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DocumentComponent, isStandalone: true, selector: "a-document", inputs: { document: "document" }, ngImport: i0, template: `
		<article style="word-break: break-all">
			<h1>{{ document.title }}</h1>
			<ng-container *ngFor="let section of document.sections">
				<h2>{{ section.index }}. {{ section.title }}</h2>
				<div [innerHTML]="section.content | safe : 'html'"></div>
				<ng-container *ngFor="let entry of section.entries">
					<h3>{{ entry.title }}</h3>
					<div [innerHTML]="entry.content | safe : 'html'"></div>
				</ng-container>
			</ng-container>
		</article>
	`, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "ngmodule", type: PipesModule }, { kind: "pipe", type: i1$1.SafePipe, name: "safe" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DocumentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'a-document', standalone: true, imports: [CommonModule, PipesModule], template: `
		<article style="word-break: break-all">
			<h1>{{ document.title }}</h1>
			<ng-container *ngFor="let section of document.sections">
				<h2>{{ section.index }}. {{ section.title }}</h2>
				<div [innerHTML]="section.content | safe : 'html'"></div>
				<ng-container *ngFor="let entry of section.entries">
					<h3>{{ entry.title }}</h3>
					<div [innerHTML]="entry.content | safe : 'html'"></div>
				</ng-container>
			</ng-container>
		</article>
	`, changeDetection: ChangeDetectionStrategy.OnPush }]
        }], ctorParameters: function () { return [{ type: i1.ActivatedRoute }]; }, propDecorators: { document: [{
                type: Input
            }] } });

class LegalDocumentComponent {
    legal;
    ref;
    locale;
    _type;
    document;
    set type(type) {
        this._type = type;
        this.fetchDocument();
        this.ref.markForCheck();
    }
    get type() {
        return this._type;
    }
    localized;
    constructor(legal, ref, locale) {
        this.legal = legal;
        this.ref = ref;
        this.locale = locale;
    }
    ngOnInit() {
        this.fetchDocument();
    }
    fetchDocument() {
        const localization = this.localized ? this.localized : this.locale;
        this.legal.getLegal(this._type, localization).subscribe((document) => {
            this.document = document;
            this.ref.markForCheck();
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LegalDocumentComponent, deps: [{ token: i1$1.LegalService }, { token: i0.ChangeDetectorRef }, { token: LOCALE_ID }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: LegalDocumentComponent, isStandalone: true, selector: "a-legal-document[type]", inputs: { type: "type", localized: "localized" }, ngImport: i0, template: `
		<div class="defaultContainer minContainer">
			<ng-container *ngIf="!document"><h1>Document not loaded</h1></ng-container>
			<ng-container *ngIf="document"><a-document [document]="document"></a-document></ng-container>
		</div>
	`, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: PipesModule }, { kind: "component", type: DocumentComponent, selector: "a-document", inputs: ["document"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LegalDocumentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'a-legal-document[type]', standalone: true, imports: [CommonModule, PipesModule, DocumentComponent], template: `
		<div class="defaultContainer minContainer">
			<ng-container *ngIf="!document"><h1>Document not loaded</h1></ng-container>
			<ng-container *ngIf="document"><a-document [document]="document"></a-document></ng-container>
		</div>
	`, changeDetection: ChangeDetectionStrategy.OnPush }]
        }], ctorParameters: function () { return [{ type: i1$1.LegalService }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }] }]; }, propDecorators: { type: [{
                type: Input
            }], localized: [{
                type: Input
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { DocumentComponent, LegalDocumentComponent };
